/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteReleaseRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/release.pb'
import {DeleteReleaseResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/release.pb'


export const deleteRelease = (request: DeleteReleaseRequest, options?: CashRequestOptions) => post<DeleteReleaseRequest, DeleteReleaseResponse>("/2.0/cash/delete-release", request, {...options, rejectOnError: true })